import {Stack, Typography, useTheme} from '@mui/material';
import React from 'react';
import {SquareLabelTimeProps} from './types';

export function SquareLabelTime({day, month}: SquareLabelTimeProps) {
	const {colors} = useTheme();
	return (
		<Stack
			sx={{
				justifyContent: 'center',
				alignItems: 'center',
				width: '56px',
				height: '56px',
				minWidth: '56px',
				minHeight: '56px',
				bgcolor: '#E0EAF6',
				borderRadius: '8px',
				color: colors.brand.primary.blue,
			}}>
			<Typography fontSize={'1.5rem'} lineHeight={'1.875rem'} fontWeight={600}>
				{day}
			</Typography>
			<Typography
				fontSize={'0.75rem'}
				lineHeight={'0.675rem'}
				fontWeight={700}
				textTransform={'uppercase'}>
				{month.slice(0, 3)}
			</Typography>
		</Stack>
	);
}
